/** Row 43 (brief 2026-10-11-001): see NoAccess.tsx. */

/**
 * Pages offered as "go to a page you can open", in order. Each `anyOf` is the page's own
 * ProtectedRoute gate in App.tsx (pinned by ProtectedRoute.noBlankPage.test.tsx), so the link
 * never leads into another refusal. Not a landing rule: getDefaultRoute is unchanged.
 */
export const NO_ACCESS_LANDINGS: { path: string; anyOf: string[] }[] = [
  { path: '/logistics/tso-dashboard', anyOf: ['logistics.dashboard.view', 'users.edit'] },
  { path: '/fleet/dashboard', anyOf: ['logistics.fleet.view', 'logistics.fleet.manage', 'users.edit'] },
  { path: '/fleet/crew-attendance', anyOf: ['crew.attendance.view'] },
  {
    path: '/transportation/teams/today',
    anyOf: ['reports.transport_team.view_own', 'reports.transport_team.view_division', 'reports.transport_team.view_all', 'users.edit'],
  },
];

export function firstOpenPage(hasAnyPermission: (codes: string[]) => boolean, currentPath: string): string | null {
  const hit = NO_ACCESS_LANDINGS.find((l) => l.path !== currentPath && hasAnyPermission(l.anyOf));
  return hit ? hit.path : null;
}
